import { useEffect, useState } from "react";
import Input from "./Input";
import Pagination from "react-js-pagination";
import GatheringManage from "./GatheringManage";
import GatheringApplication from "./GatheringApplication";
import GatheringFinish from "./GatheringFinish";
import GatheringInfo from "./GatheringInfo";
import GatheringBoardManage from "./GatheringBoardManage";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setModalState, setStep } from "../redux/communityStepSlice";

//소모임 관련 팝업
const GatheringModalWrap = ({ }) => {
    const dispatch = useDispatch();
    const { step, modalState } = useSelector((s) => s.communityStepReducer);

    const [innerStep, setInnerStep] = useState(1);
    const [reInsertData, setReInsertData] = useState(null);

    const handleStepChange = (newStep) => {
        dispatch(setStep(newStep));
    };
    const handleModalState = (state) => {
        dispatch(setModalState(state));
    };

    // InnerStep 이동 처리
    const moveInnnerStep = (stepIndex, data = null) => {
        setInnerStep(stepIndex);
        if ((step === 2 || 1) && data) {
            // 소모임 재신청일 경우
            setInnerStep(stepIndex);
            setReInsertData(data)
        } else {
            setInnerStep(stepIndex);
            setReInsertData(null)
        }
    }

    useEffect(() => {
        console.log("?!", modalState);
    }, [modalState]);

    return (
        //해더 부분
        <div className="community_modal">
            {innerStep === 1 && (
                <div
                    className="community_modal_header"
                    style={{ position: step !== 1 ? "relative" : "absolute" }}
                >
                    {step === 1 && (
                        <>
                            <p>소모임</p>
                            <img
                                src={`./images/icons/x.svg`}
                                onClick={() => handleModalState(!modalState)}
                            />
                        </>
                    )}
                    {step === 2 && <p>신규 소모임 신청</p>}
                    {step === 3 && <p>소모임</p>}
                    {step === 4 && <>
                        <p>소모임 관리</p>
                        <img
                            src={`./images/icons/x.svg`}
                            onClick={() => handleModalState(!modalState)}
                        />
                    </>}
                </div>
            )}

            {/* 모달 내용 부분 */}
            {/*소모임 검색 관리를 클릭했을때  */}
            {(step === 1 || step == 3) && (
                <GatheringManage
                    step={step}
                    setStep={handleStepChange}
                    setInnerStep={moveInnnerStep}
                />
            )}
            {/*신규 소모임 신청 */}
            {step === 2 && innerStep === 1 && (
                <GatheringApplication
                    setInnerStep={moveInnnerStep}
                    setStep={handleStepChange}
                    detailInfo={reInsertData}
                />
            )}
            {/* 신규 소모임 신청 정보 */}
            {step === 2 && innerStep === 2 && (
                <GatheringFinish
                    innerStep={innerStep}
                    setInnerStep={moveInnnerStep}
                    setStep={handleStepChange}
                />
            )}
            {/* 신규 소모임 신청 상태 */}
            {step === 2 && innerStep === 3 && (
                <GatheringFinish
                    innerStep={innerStep}
                    setInnerStep={moveInnnerStep}
                    setStep={handleStepChange}
                />
            )}
            {/* 소모임 게시판에서 소모임 관리 버튼 */}
            {step === 4 && (
                <GatheringBoardManage setModalState={handleModalState} groupIdx={""} />
            )}
        </div>
    );
};
export default GatheringModalWrap;
